import React, { useContext } from 'react'
import { useFormContext } from 'react-hook-form'

import FormContext from '@/components/form/form-context'

import * as styles from './checkbox.module.scss'

type Props = {
  id: string
  label: string
  small?: boolean
  disabled?: boolean
}
const Checkbox: React.FC<Props> = ({
  id,
  label,
  small = false,
  disabled = false
}) => {
  const formContext = useContext(FormContext)
  const {
    formState: { errors },
    register
  } = useFormContext()
  return (
    <div
      className={[
        `${styles.checkboxitem} ${small ? styles.legalText : ''}`,
        formContext?.classes?.checkbox
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <div
        className={`${styles.boxcheckbox} ${errors[id] ? styles.error : ''}`}
      >
        <input
          id={id}
          {...register(id)}
          type="checkbox"
          data-testid={id}
          disabled={disabled}
        />
      </div>

      <label htmlFor={id} dangerouslySetInnerHTML={{ __html: label }} />
      {errors[id] && <span>This field is mandatory</span>}
    </div>
  )
}
export default Checkbox
